import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { Grid, TextField, ButtonGroup, FormControl, MenuItem, Select } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import styled from 'styled-components';
import { color } from 'styles/utils';
import cx from 'classnames';
import useInput from 'lib/hooks/useInput';
import { useDidUpdateEffect } from 'lib/utils';
import MuiWrapper from 'components/common/input/MuiWrapper';
import MuiButton from 'components/common/button/MuiButton';
import T from 'components/common/text/T';
import { icon_user_circle, icon_trash } from 'components/base/images';
import { StyledPlainButtonOuter } from 'components/common/styled/Button';
import ImgCrop from 'components/common/images/ImgCrop';
import CustomSpan from 'components/common/text/CustomSpan';
import IconButton from '@material-ui/core/IconButton';
import Color from 'color';
import { getStringByte, regPhoneNumber } from 'lib/library';
import { AppActions } from 'store/actionCreators';
import AlertModalContent from 'components/common/modal/contents/AlertModalContent';
import { useTranslation } from 'react-i18next';
import { IPartnerProfileImage, IPartnerData, IAccountTypeList } from 'lib/types/partnerTypes';
import { useShallowAppSelector } from 'store/hooks';
import CheckIcon from 'components/base/icons/CheckIcon';
interface ChatFileUploadPopupProps {
  isAskAgain: {
    value: boolean;
    onChange: (e: any) => void;
    setValue: (value: boolean) => void;
  };
  notSupportFiles: string[];
  uploadFileList: {
    value: any;
    onChange: (e: any) => void;
    setValue: (value: any) => void;
  };
  // notSupportFiles: {
  //   value: string[];
  //   onChange: (e: any) => void;
  //   setValue: (value: string[]) => void;
  // };
  onClickTransfer: () => void;
  onClickPopupCancel: () => void;
}

/**
 * @param {ChatFileUploadPopupProps} { selectedPartner }
 * @return {*}
 */
function ChatFileUploadPopup({
  isAskAgain,
  notSupportFiles,
  uploadFileList,
  onClickTransfer,
  onClickPopupCancel,
}: ChatFileUploadPopupProps) {
  const { user, language } = useShallowAppSelector(state => ({
    user: state.user.user,
    language: state.base.language,
  }));
  const { t } = useTranslation();
  const [popupState, setPopupState] = useState<number>(0);

  useEffect(() => {
    console.log('notSupportFiles ______ ', notSupportFiles);
  }, [notSupportFiles]);
  useEffect(() => {
    return () => {
      setPopupState(0);
    };
  }, []);

  useEffect(() => {
    if (uploadFileList.value.length > 5) {
      // too many files
      setPopupState(3);
    } else if (notSupportFiles.length > 0) {
      // not support files exist
      setPopupState(2);
    } else {
      // file transfer
      setPopupState(1);
    }
  }, [uploadFileList.value, notSupportFiles]);

  const transferState = [
    {
      state: 1,
      title: t('CHAT_FILE_TRANSFER'),
      details: t('CHAT_FILE_TRANSFER_DETAIL'),
    },
    {
      state: 2,
      title: t('CHAT_FILE_TRANSFER_FAIL'),
      details: t('CHAT_FILE_TRANSFER_FAIL_DETAIL'),
    },
    {
      state: 3,
      title: t('CHAT_FILE_TRANSFER_FAIL'),
      details: t('CHAT_FILE_TRANSFER_FAIL_MAX_FILE'),
    },
  ];
  return (
    <StyledChatFileUploadPopup data-component-name="ChatFileUploadPopup">
      <h1 className="sr-only">ChatPopup</h1>
      <div className="chatFileUploadPopup__container">
        <div className="chatFileUploadPopup__title_box">
          <div className="chatFileUploadPopup__title">
            {/* {uploadFileList.value.length > 5 || notSupportFiles.length > 0 ? (
              <T>CHAT_FILE_TRANSFER_FAIL</T>
            ) : (
              <T>CHAT_FILE_TRANSFER</T>
            )} */}
            {transferState.find((item: any) => item.state === popupState)?.title}
          </div>
          <div className="chatFileUploadPopup__title_detail">
            {/* {notSupportFiles.length > 0 ? (
              <T>CHAT_FILE_TRANSFER_FAIL_DETAIL</T>
            ) : (
              <T>CHAT_FILE_TRANSFER_DETAIL</T>
            )} */}
            {transferState.find((item: any) => item.state === popupState)?.details}
          </div>
        </div>
        <div className="chatFileUploadPopup__files_box">
          <div
            className={cx('chatFileUploadPopup__file_list', {
              notSupport: popupState !== 1,
              support: popupState === 1,
            })}
          >
            {popupState === 1 &&
              uploadFileList.value.map((item: any, idx: number) => {
                return (
                  <div key={idx} className="chatFileUploadPopup__file_row">
                    <span>{`- ${item.name}`}</span>
                  </div>
                );
              })}

            {popupState === 2 &&
              notSupportFiles.map((item: string, idx: number) => {
                return (
                  <div key={idx} className="chatFileUploadPopup__file_row">
                    <span>{`- ${item}`}</span>
                  </div>
                );
              })}
          </div>
        </div>
        <div className="chatFileUploadPopup__button_box">
          {popupState !== 1 ? (
            <>
              <div className="chatFileUploadPopup__button_group button notSupport">
                <MuiButton
                  disableElevation
                  variant="contained"
                  color="primary"
                  className="chatFileUploadPopup__button"
                  onClick={onClickPopupCancel}
                >
                  <T>GLOBAL_OK</T>
                </MuiButton>
              </div>
            </>
          ) : (
            <>
              <div className="chatFileUploadPopup__button_group notAgainAsk">
                <div
                  className="notAgainAsk__box"
                  onClick={() => {
                    isAskAgain.setValue(!isAskAgain.value);
                  }}
                >
                  <span
                    className="notAgainAsk__checkbox"
                    style={{
                      borderColor: isAskAgain.value ? 'transparent' : '#ccc',
                      backgroundColor: isAskAgain.value ? '#00a4e3' : 'transparent',
                    }}
                  >
                    {isAskAgain.value && <CheckIcon />}
                  </span>
                  <T>GLOBAL_NOT_AGAIN</T>
                </div>
              </div>
              <div className="chatFileUploadPopup__button_group button">
                <MuiButton
                  disableElevation
                  variant="contained"
                  color="primary"
                  className="chatFileUploadPopup__button"
                  onClick={onClickTransfer}
                >
                  <T>GLOBAL_OK</T>
                </MuiButton>
                <MuiButton
                  disableElevation
                  variant="outlined"
                  color="primary"
                  className="chatFileUploadPopup__button"
                  onClick={onClickPopupCancel}
                >
                  <T>GLOBAL_CANCEL</T>
                </MuiButton>
              </div>
            </>
          )}
        </div>
      </div>
    </StyledChatFileUploadPopup>
  );
}

const StyledChatFileUploadPopup = styled.section<{}>`
  .chatFileUploadPopup__container {
    width: 300px;
    height: 228px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.16);
    border: solid 1px #d1d1d1;
    padding: 20px;

    .chatFileUploadPopup__title_box {
      width: 100%;
      margin-bottom: 5px;
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      justify-content: center;
      .chatFileUploadPopup__title {
        font-size: 14px;
        font-weight: 500;
        color: #444;
      }
      .chatFileUploadPopup__title_detail {
        font-size: 12px;
        font-weight: 400;
        color: #444;
        line-height: 17px;
      }
    }
    .chatFileUploadPopup__files_box {
      width: 100%;
      margin-bottom: 10px;
      .chatFileUploadPopup__file_list {
        overflow-y: overlay;
        overflow-x: hidden;
        &.support {
          height: 62px;
          .chatFileUploadPopup__file_row {
            height: 20px;
            width: 260px;
            padding-right: 20px;
            display: inline-flex;
            align-items: center;
            span {
              width: inherit;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 12px;
              color: #888;
            }
          }
        }
        &.notSupport {
          height: 74px;
          .chatFileUploadPopup__file_row {
            width: 260px;
            padding-right: 20px;
            display: inline-flex;
            align-items: center;
            span {
              font-size: 12px;
              color: #888;
              width: inherit;
              word-break: break-all;
            }
          }
        }
      }
    }
    .chatFileUploadPopup__button_box {
      display: flex;
      flex-direction: column;
      row-gap: 20px;
      .chatFileUploadPopup__button_group {
        display: flex;
        align-items: center;

        &.notAgainAsk {
          height: 20px;
          .notAgainAsk__box {
            display: inline-flex;
            align-items: center;
            font-size: 12px;
            color: #888;
            .notAgainAsk__checkbox {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              margin-right: 10px;
              width: 20px;
              height: 20px;
              border-radius: 4px;
              background-color: transparent;
              border: 1px solid white;
            }
          }
        }
        &.button {
          justify-content: center;
          column-gap: 5px;
          .chatFileUploadPopup__button {
            width: 84px;
            height: 28px;
            font-size: 12px;
          }
        }
        &.notSupport {
          margin-top: 10px;
        }
      }
    }
  }
`;

export default React.memo(ChatFileUploadPopup);
